import {Filedescription} from './filedescription';
import {Company} from './company';
import {Job} from './job';
export class Jobapplication {
    UserId: number;
    Id: number;
    JobId: number;    
    CvSuitablityTypeId?: any;
    CandidateSelfSuitableTypeId?: any;
    CvFeedbackTypeId?: any;
    ResumeId: number;
    CoveringLetter: string;
    AppliedOn: Date;
    IsViewedByRecruiter: boolean;
    RecruiterViewedOn?: any;
    CandidateSelfNotes: string;
    EmployerSelfNotes: string;
    ConsultantNotes: string;
    FileDescription?: any;
    IsDeleted: boolean;
    Company: Company;
    Job: Job;
   // IsSendSelfNotification:boolean;
    IsEmailSimilarJobs:boolean;
    IsPersonalityAssessment:boolean;
    AttachedDocumentDescription?:any;
    IsExternal:boolean;
    AppliedById: number;
}
